import React from 'react';

import styles from "./Overlay.module.scss";
import {useDispatch, useSelector} from "react-redux";
import OverlayAllItem from "../OverlayAllItem/OverlayAllItem";
import OverlayGroup from "../OverlayGroup/OverlayGroup";
import {handleSearchValueSubmit} from "../../Store/Actions/NewFilterActions";

const Overlay = () => {
    const newFilterState = useSelector(state => state.newFilterReducer);
    const dispatch = useDispatch();

    const acSearchResultRaw = newFilterState.acSearchResult;

    const total = acSearchResultRaw ? acSearchResultRaw['hydra:totalItems'] : 0;

    const getResultGroups = (results) => {
        let groupsItems = {};
        let groupsData = {};
        results.map(result => {
            const mainFacet = result['main_facet'];
            if (groupsItems[mainFacet] === undefined) {
                groupsItems[mainFacet] = [];
                groupsData[mainFacet] = {
                    title: result.main_facet,
                    url: result.url
                };
            }
            groupsItems[mainFacet].push(result);
            return true;
        });
        return {groupsItems: groupsItems, groupsData: groupsData};
    };

    // Initialize variables.
    let resultsRaw = null;
    let results = [];
    let resultGroups = [];
    let groupsItems = null;
    let groupsData = null;


    if (acSearchResultRaw) {
        resultsRaw = acSearchResultRaw['hydra:member'];
        const resultGroupsRaw = getResultGroups(resultsRaw);
        groupsItems = resultGroupsRaw.groupsItems;
        groupsData = resultGroupsRaw.groupsData;

        // Populate "Alle treff".
        results = acSearchResultRaw['hydra:member'].map((result, i) => {
            return <OverlayAllItem key={result['@id']}
                                   title={result.title}
                                   type={result.type}
                                   programStatus={result.program_status}
                                   forsteSemester={result.forste_semester}
                                   sisteSemester={result.siste_semester}
                                   url={result.url}
                                   keybActive={i === newFilterState.acKeyboardPosition} />
        });

        // Populate groupped results.
        // We want the Verktøy, Utdanninger and Yrker to be on top.
        if (groupsItems['Verktøy'] !== undefined) {
            resultGroups.push(<OverlayGroup key="Verktøy" title={groupsData['Verktøy'].title} items={groupsItems['Verktøy']} />);
            delete groupsItems['Verktøy'];
        }
        if (groupsItems['Utdanninger'] !== undefined) {
            const utdanninger = groupsItems['Utdanninger'].filter(utd => utd.type === 'Utdanningsoversikt');
            resultGroups.push(<OverlayGroup key="Utdanninger" title={groupsData['Utdanninger'].title} items={utdanninger} />);
            delete groupsItems['Utdanninger'];
        }
        if (groupsItems['Yrker'] !== undefined) {
            resultGroups.push(<OverlayGroup key="Yrker" title={groupsData['Yrker'].title} items={groupsItems['Yrker']} />);
            delete groupsItems['Yrker'];
        }
        Object.keys(groupsItems).forEach(function(key) {
            const groupItems = groupsItems[key];
            const groupTitle = groupsData[key].title;
            resultGroups.push(<OverlayGroup key={groupTitle} title={groupTitle} items={groupItems} />);
        });
    }

    const handleSeAllClick = () => {
        const searchValue = newFilterState.acSearchInputValue;
        dispatch(handleSearchValueSubmit(searchValue));
    };

    // No results.
    if (total === 0) {
        return (
            <div className={styles.container}>
                <div className={styles.content}>
                    Ingen treff
                </div>
            </div>
        );
    }

    // Yes results.
    return (
        <>
            <div onClick={handleSeAllClick} className={styles.overlay}></div>
            <div className={styles.container}>
                <div className={styles.content}>

                    <div onClick={handleSeAllClick} className={styles.buttonwrapper}>
                        <div className={styles.button}>Se alle {total} treff</div>
                    </div>

                    <div className={styles.all}>
                        <div className={styles.header}>
                            <h2>Alle treff</h2>
                        </div>
                        <div className={styles.body}>
                            {results}
                        </div>
                    </div>

                    <div className={styles.groups}>
                        {resultGroups}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Overlay;
